module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 102.60f8d0e2.png";